import clsx from 'classnames'
import { ReactNode } from 'react'
import styles from '@components/FooterBackgroundWrapper.module.scss'

interface FooterBackgroundWrapperProps {
  children: ReactNode
  footerWithBackground: boolean
  withTopOffset?: boolean
}

export const FooterBackgroundWrapper = ({
  children,
  footerWithBackground,
  withTopOffset = false,
}: FooterBackgroundWrapperProps) => {
  if (!footerWithBackground) {
    return (
      <div className={clsx({ [styles.rootTopOffset]: withTopOffset })}>
        {children}
      </div>
    )
  }

  return (
    <div
      className={clsx(styles.rootBackgroundWrapper, {
        [styles.rootTopOffset]: withTopOffset,
      })}
    >
      {children}
    </div>
  )
}
